// 1. Centralized Status Configuration
export const STATUS_OPTIONS = [
  { value: "Draft", label: "Draft" },
  { value: "Processing", label: "Processing" },
  { value: "Completed", label: "Completed" },
  { value: "Cancelled", label: "Cancelled" },
];

export const getStatusConfig = (status) => {
  const configs = {
    Draft: {
      bgColor: 'bg-gray-100',
      textColor: 'text-gray-800',
      borderColor: 'border-gray-300',
      dotColor: 'bg-gray-500',
      ringColor: 'focus:ring-gray-400'
    },
    Processing: {
      bgColor: 'bg-blue-100',
      textColor: 'text-blue-800',
      borderColor: 'border-blue-300',
      dotColor: 'bg-blue-500',
      ringColor: 'focus:ring-blue-400'
    },
    Completed: {
      bgColor: 'bg-green-100',
      textColor: 'text-green-800',
      borderColor: 'border-green-300',
      dotColor: 'bg-green-500',
      ringColor: 'focus:ring-green-400'
    },
    Cancelled: {
      bgColor: 'bg-red-100',
      textColor: 'text-red-800',
      borderColor: 'border-red-300',
      dotColor: 'bg-red-500',
      ringColor: 'focus:ring-red-400'
    }
  };
  return configs[status] || configs.Draft;
};

export function StatusSelect({ 
    value, 
    onChange, 
    label, 
    isRequired, 
    error, 
    errorMessage,
    showLabel = true, // Set false for table use
    disabled = false
}) {
  const status = value || 'Draft';
  const config = getStatusConfig(status);

  return (
    <div className="w-full">
      {showLabel && label && (
        <label className="block text-sm font-medium text-gray-600 mb-1">
          {label} {isRequired && <span className="text-red-500">*</span>}
        </label>
      )}
      
      <div className="relative group">
        <select
          value={status}
          onChange={onChange}
          disabled={disabled}
          className={`
            w-full min-w-[120px] 
            ${config.bgColor} ${config.textColor} ${config.borderColor}
            border rounded-lg pl-8 pr-8 py-1.5
            text-sm font-medium
            appearance-none cursor-pointer
            transition-all duration-200
            focus:outline-none focus:ring-2 focus:ring-opacity-50 
            ${config.ringColor}
            ${disabled ? 'opacity-60 cursor-not-allowed' : 'hover:shadow-sm'}
            ${error ? 'border-red-500' : ''}
          `}
        >
          {STATUS_OPTIONS.map(opt => (
            <option key={opt.value} value={opt.value} className="bg-white text-gray-800">
              {opt.label}
            </option>
          ))}
        </select>

        {/* Dropdown Arrow Icon */}
        <div className="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
          <svg className={`w-4 h-4 ${config.textColor}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
          </svg>
        </div>

        {/* Status Colored Dot */}
        <div className="absolute left-3 top-1/2 transform -translate-y-1/2">
          <div className={`w-2 h-2 rounded-full ${config.dotColor}`}></div>
        </div>
      </div>

      {showLabel && error && errorMessage && (
        <p className="mt-1 text-xs text-red-500">{errorMessage}</p>
      )}
    </div>
  );
}